import tabsView from './tabsComponent.html';
import './tabsComponent.css';

export function tabsComponent() {
	return {
		bindings: {
			height: '<?',
		},
		transclude: true,
		controllerAs: 'vm',
		controller: tabsComponentCtrl,
		template: tabsView,
	};
}

export class tabsComponentCtrl {
	constructor($element) {
		'ngInject';
		this.$element = $element;
	}

	$onInit() {
		this.tabs = [];
	}

	getHeightCss() {
		const height = this.height == 'full' ? '100%' : this.height;
		if (/^[\d.]+%$/.test(height)) {
			// percentage
			this.$element.css('height', height);
			return `calc(${height} - 35px)`; // 35px is height of tabs
		} else if (this.height < 0) {
			this.$element.css('height', `calc(100% - ${this.height}px)`);
			return `calc(100% - ${-1 * this.height + 35}px)`; // 35px is height of tabs
		} else if (this.height > 0) {
			this.$element.css('height', this.height + 'px');
			return this.height + 'px';
		}
	}

	tabClick(vm) {
		if (vm.isOpen) {
			// already open
			return;
		}
		this.tabs.forEach(tab => tab.setState(tab === vm));
	}

	registerTab(vm) {
		this.tabs.push(vm);
	}

	unregisterTab(vm) {
		const idx = this.tabs.indexOf(vm);
		this.tabs.splice(idx, 1);
	}
}
